

import { CategoryReference } from 'apprise-core/category'
import { Tag, TagReference } from 'apprise-core/tag'
import { createProvider } from 'apprise-frontend-core/state/factory'
import { createFormExcludes } from 'apprise-frontend-core/utils/formexcludes'

// tags 
// -------------------------------------------------------------------------------------------

export const [TagClientCache, useTagClientCache] = createProvider({

    all: [] as Tag[],
})



// external tags
// -------------------------------------------------------------------------------------------


export const [ExternalClientCache, useExternalClientCache] = createProvider({

    all: {} as Record<CategoryReference, Record<TagReference, Tag>>,
    allCodes: {} as Record<CategoryReference, Record<string, Tag>>
})




// clone
// -------------------------------------------------------------------------------------------


export const [TagCloneProvider, useTagClone] = createProvider({

    clone: undefined! as Tag

})


// excludes

type TagExcludes =

    'value'             // excludes tag value, deperecated and disabled by default.
    | 'active'           // excludes activations toggle, all tags are active.
    | 'condition'       // excludes tag dependencies as conditions on tag inclusion in fields.


export const [TagExcludesProvider, useTagExcludes] = createFormExcludes<TagExcludes>({

    properties: ['value']

})